
@switch (columnId) {
  @case (TransactionOrderBy.Amount) {
    <lib-text-table-column>
      {{ element.amount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case (TransactionOrderBy.TransactionId) {
    <lib-text-table-column>
      {{ element.transactionId }}
    </lib-text-table-column>
  }
  @case (TransactionOrderBy.TransactionType) {
    <lib-text-table-column>
      {{ displayTextForTransactionType }}
    </lib-text-table-column>
  }
  @case ('TransactionStatus') {
    <lib-transaction-status-chip
      [status]="element?.status">
    </lib-transaction-status-chip>
  }
  @case (TransactionOrderBy.PayerName) {
    <lib-text-table-column>
      {{ getDisplayTextForPayerName() }}
    </lib-text-table-column>
  }
  @case ('CardBrand') {
    @if (element.card?.cardBrand) {
      <span class="card-image">
        <i [class]="'fab fa-cc-' + element.card.cardBrand.toLowerCase() + ' fa-2x'"></i>
      </span>
    }
    @if (!element.card?.cardBrand) {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @case (TransactionOrderBy.CardNumber) {
    <lib-text-table-column>
      {{ getDisplayTextForCardNumber() }}
    </lib-text-table-column>
  }
  @case (TransactionOrderBy.DateAndTime) {
    <lib-date-time-label [dateUtc]="element.dateUtc"></lib-date-time-label>
  }
  @case ('AuthCode') {
    <lib-text-table-column>
      {{ element.authCode }}
    </lib-text-table-column>
  }
  @case ('Fees') {
    <lib-text-table-column>
      {{ element.fees | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case ('DigitalWallet') {
    <lib-digital-wallet-image-table-column
      [kind]="element.digitalWallet">
    </lib-digital-wallet-image-table-column>
  }
  @case ('TransactionToken') {
    <lib-text-table-column>
      {{ element.token }}
    </lib-text-table-column>
  }
  @default {
  }
}





